import { createSlice } from '@reduxjs/toolkit';

export type TransitionPreparationType = {
  id: string;
  stayTheSameComment: string | null;
  supportThisParticipationComment: string | null;
  gapsWhenChildLeavesEiComment: string | null;
  listActivitiesServiceComment: string | null;
  changesInEiServiceComment: string | null;
  transitionPreparationDate: string | null;
};

export type TransitionPlanType = {
  id: string;
  isTransitionPlanDone: boolean;
  transitionPlanDate: string;
  noTransitionPlanReason: string;
  needToDoComment: string;
  isTpcMeetingDone: boolean;
  meetingDate: string;
  transitionConferenceDeclinedDate: string;
  noTpcReason: string;
  arrangeTpc: boolean;
  leaInvited: boolean;
  leaRepParticipate: boolean;
  potentiallyLeaEligible: boolean;
  whoParticipatedComment: string;
  notifyChildPotentialEligibility: boolean;
  consentShare: boolean;
  leaConsent: boolean;
  consentDate: string;
  sectionDetermine: boolean;
  specifyComment: string;
  makeReferral: boolean;
  dateOfReferralToLea: string;
  outsideTpcReason: string;
  noReferralMade: boolean;
  leaOptOutDate: string;
  seaStatus: string;
  tbrTransitionId: number;
  tbrUpdateRequired: boolean;
};

export type IfspTransitionDataType = {
  ifspId: string;
  transitionPreparation: TransitionPreparationType;
  transition: TransitionPlanType;
  heldBy: string | null;
  isCurrentlyHeld: boolean;
  displayBanner: boolean;
};

export type InitialTransitionDataType = {
  ifspTransitionData: IfspTransitionDataType;
  ifspOriginalTransitionData: IfspTransitionDataType;
};

const initialData: IfspTransitionDataType = {
  ifspId: '',
  heldBy: null,
  isCurrentlyHeld: false,
  displayBanner: false,
  transitionPreparation: {
    id: '',
    stayTheSameComment: '',
    supportThisParticipationComment: '',
    gapsWhenChildLeavesEiComment: '',
    listActivitiesServiceComment: '',
    changesInEiServiceComment: '',
    transitionPreparationDate: '',
  },
  transition: {
    id: '',
    isTransitionPlanDone: false,
    transitionPlanDate: '',
    noTransitionPlanReason: '',
    needToDoComment: '',
    isTpcMeetingDone: false,
    meetingDate: '',
    transitionConferenceDeclinedDate: '',
    noTpcReason: '',
    arrangeTpc: false,
    leaInvited: false,
    leaRepParticipate: false,
    potentiallyLeaEligible: false,
    whoParticipatedComment: '',
    notifyChildPotentialEligibility: false,
    consentShare: false,
    leaConsent: false,
    consentDate: '',
    sectionDetermine: false,
    specifyComment: '',
    makeReferral: false,
    dateOfReferralToLea: '',
    outsideTpcReason: '',
    noReferralMade: false,
    leaOptOutDate: '',
    seaStatus: '',
    tbrTransitionId: 0,
    tbrUpdateRequired: false,
  },
};

const initialTransitionData: InitialTransitionDataType = {
  ifspTransitionData: initialData,
  ifspOriginalTransitionData: initialData,
};

const ifspTransitionSlice = createSlice({
  name: 'ifspTransition',
  initialState: initialTransitionData,
  reducers: {
    setIfspTransition: (state, action) => {
      state.ifspTransitionData = action.payload;
      state.ifspOriginalTransitionData = action.payload;
    },
    updateIfspTransition: (state, action) => {
      return { ...state, ifspTransitionData: action.payload };
    },
    updateOriginalIfspTransition: (state, action) => {
      return { ...state, ifspOriginalTransitionData: action.payload };
    },
    resetIfspTransition: () => {
      return initialTransitionData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_REDUX_APP_STATES', () => initialTransitionData);
  },
});

export const {
  setIfspTransition,
  updateIfspTransition,
  updateOriginalIfspTransition,
  resetIfspTransition,
} = ifspTransitionSlice.actions;
export default ifspTransitionSlice.reducer;
